import clientNamesData from '../../data/clientNamesData.json'
import { ClientData } from './type'


export class ClientSearchService {
  private clients: ClientData[] = clientNamesData as unknown as ClientData[]

  searchClientsByName(searchText: string, limit: number = 10, clientId?: number): ClientData[] {
    if (!searchText || searchText.trim().length === 0) {
      return []
    }

    const normalizedSearch = searchText.toLowerCase().trim()

    let filteredClients = this.clients
      .filter(client =>
        client.name.toLowerCase().startsWith(normalizedSearch)
      )

    if (clientId !== undefined) {
      filteredClients = filteredClients.filter(client => client.id === clientId)
    }

    return filteredClients.slice(0, limit)
  }

  searchClientsByRut(searchText: string, limit: number = 10): ClientData[] {
    if (!searchText || searchText.trim().length === 0) {
      return []
    }

    // Remover puntos y guiones para la búsqueda
    const normalizedSearch = searchText.replace(/[.-]/g, '').trim()

    return this.clients
      .filter(client => {
        const normalizedRut = client.rut.replace(/[.-]/g, '')
        return normalizedRut.startsWith(normalizedSearch)
      })
      .slice(0, limit)
  }

  getClientByRut(rut: string): ClientData | null {
    return this.clients.find(client => client.rut === rut) || null
  }

  async searchClientsAsync(searchText: string, limit: number = 10, clientId?: number): Promise<ClientData[]> {
    await new Promise(resolve => setTimeout(resolve, 200))
    return this.searchClientsByName(searchText, limit, clientId)
  }

  async searchClientsByRutAsync(searchText: string, limit: number = 10): Promise<ClientData[]> {
    await new Promise(resolve => setTimeout(resolve, 200))
    return this.searchClientsByRut(searchText, limit)
  }
}
